// eslint-disable-next-line no-shadow
enum OnboardingStatus {
    DISABLE = 'DISABLE',
    INITIAL = 'INITIAL',
    MANUAL = 'MANUAL',
  }

export { OnboardingStatus as default };
